'use client'

import Link from 'next/link'
import { BOTTOM_NAV_ICON_MAP } from '@/shared/constants/icon-map'
import { usePathname, useSearchParams } from 'next/navigation'
import { Typography } from '../../atoms'
import { useAuthContext } from '@/app/providers/AuthProviders'
import { useRouteStore } from '@/shared/stores/data/store'

const BottomNav = () => {
  const { loggedIn } = useAuthContext()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const pushPath = useRouteStore((s) => s.pushPath)
  const localePrefix = pathname?.length && pathname?.length >= 3 ? pathname?.slice(0, 3) : ""
  const fullPath = searchParams?.toString()
    ? `${pathname}?${searchParams?.toString()}`
    : pathname

  const getActiveIcon = (expression: string) => {
    const path = pathname?.slice(3) || ''
    if('/' === expression) {
      const list = ['/', '']
      return list.includes(path)
    }
    if('/search' === expression) {
      const list = ['/search']
      return list.includes(path)
    }
    if('/treatment-case' === expression) {
      return path === '/treatment-case' || path.startsWith('/treatment-case/')
        || path === '/health-info' || path.startsWith('/health-info/')
    }
    if('/my' === expression) {
      const list = ['/my','/my/profile','/my/settings','/my/notifications','/my/messages','/my/reviews','/my/favorites','/my/settings']
      return list.includes(path)
    }
    return false
  }

  const labelClass = (pathKey: string) =>
    `${getActiveIcon(pathKey) ? 'text-primary-600' : 'text-gray-500'} font-medium`

  const signInHref = `${localePrefix}/sign-in`
  const myHref = `${localePrefix}/my`
  const trackCurrentRoute = () => {
    if (!fullPath) return
    pushPath(fullPath)
  }

  return (
    <div id="bottom-nav" className="relative z-[99]">
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full min-w-[375px] max-w-[600px] mx-auto flex h-16 items-center justify-between gap-10 px-5 pt-2 pb-[14px] bg-white border-t border-gray-200 shadow-[0_-2px_14px_0_rgba(215,210,219,1)]">
        <Link
          href={`${localePrefix}/`}
          className="w-full flex flex-col items-center justify-center gap-[2px]"
          onClick={trackCurrentRoute}
        >
          {BOTTOM_NAV_ICON_MAP.home && <BOTTOM_NAV_ICON_MAP.home className={`${getActiveIcon('/') ? 'text-primary-600' : 'text-gray-300'}`} />}
          <Typography size={12} lineHeight={16} className={labelClass('/')}>홈</Typography>
        </Link>
        <Link
          href={`${localePrefix}/search`}
          className="w-full flex flex-col items-center justify-center gap-[2px]"
          onClick={trackCurrentRoute}
        >
          {BOTTOM_NAV_ICON_MAP.search && <BOTTOM_NAV_ICON_MAP.search className={`${getActiveIcon('/search') ? 'text-primary-600' : 'text-gray-300'}`} />}
          <Typography size={12} lineHeight={16} className={labelClass('/search')}>검색</Typography>
        </Link>
        <Link
          href={`${localePrefix}/treatment-case`}
          className="w-full flex flex-col items-center justify-center gap-[2px]"
          onClick={trackCurrentRoute}
        >
          {BOTTOM_NAV_ICON_MAP.treatmentCase && <BOTTOM_NAV_ICON_MAP.treatmentCase className={`${getActiveIcon('/treatment-case') ? 'text-primary-600' : 'text-gray-300'}`} />}
          <Typography size={12} lineHeight={16} className={labelClass('/treatment-case')}>콘텐츠</Typography>
        </Link>
        <Link
          href={loggedIn ? myHref : signInHref}
          prefetch={false}
          className="w-full flex flex-col items-center justify-center gap-[2px]"
          onClick={trackCurrentRoute}
        >
          {BOTTOM_NAV_ICON_MAP.my && <BOTTOM_NAV_ICON_MAP.my className={`${getActiveIcon('/my') ? 'text-primary-600' : 'text-gray-300'}`} />}
          <Typography size={12} lineHeight={16} className={labelClass('/my')}>마이페이지</Typography>
        </Link>
      </div>
    </div>
  )
}

export default BottomNav
